import type { TourDef } from '../types';
import admin from './admin';
import hr from './hr';
import member from './member';

/** Every tour, by id. A topic's `tour:` must name one of these (a test checks). */
export const TOURS: Record<string, TourDef> = { member, hr, admin };

/** The tour offered first to someone, by their highest role (see primaryHelpRole). */
export const WELCOME_TOUR: Record<'member' | 'hr' | 'admin', string> = { member: 'member', hr: 'hr', admin: 'admin' };

export function getTour(id: string | null | undefined): TourDef | null {
  return (id && TOURS[id]) || null;
}
